import { render, staticRenderFns } from "./mutabakatmektubu.vue?vue&type=template&id=bc2b2f22&"
import script from "./mutabakatmektubu.vue?vue&type=script&lang=js&"
export * from "./mutabakatmektubu.vue?vue&type=script&lang=js&"
import style0 from "./mutabakatmektubu.vue?vue&type=style&index=0&id=bc2b2f22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports